import { FunctionComponent, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BlueskyShareButton,
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import { ConfigContext } from '../../../context';
import { IconLabel } from '../IconLabel';

import classes from './ShareUrlViaSocial.module.scss';

interface ShareUrlViaSocialProps {
  url: string;
  subject: string;
  body: string;
}

export const ShareUrlViaSocial: FunctionComponent<ShareUrlViaSocialProps> = memo(
  ({ url, subject, body }) => {
    const { t } = useTranslation();

    const {
      emailEnabled = true,
      facebookEnabled = true,
      xEnabled = true,
      linkedinEnabled = true,
      blueskyEnabled = true,
    } = { ...useContext(ConfigContext).config.elements.sharePost };

    return (
      <div className={classes['share-list']}>
        {emailEnabled && (
          <EmailShareButton url={url} subject={subject} body={body} aria-label={t('common.email')}>
            <IconLabel iconId={'share-email'} className={classes['share-list__item']} />
          </EmailShareButton>
        )}

        {facebookEnabled && (
          <FacebookShareButton url={url} aria-label={'Facebook'}>
            <IconLabel iconId={'share-facebook'} className={classes['share-list__item']} />
          </FacebookShareButton>
        )}

        {xEnabled && (
          <TwitterShareButton url={url} aria-label={'X'}>
            <IconLabel iconId={'share-x'} className={classes['share-list__item']} />
          </TwitterShareButton>
        )}

        {linkedinEnabled && (
          <LinkedinShareButton url={url} aria-label={'LinkedIn'}>
            <IconLabel iconId={'share-linkedin'} className={classes['share-list__item']} />
          </LinkedinShareButton>
        )}

        {blueskyEnabled && (
          <BlueskyShareButton url={url} aria-label={'Bluesky'}>
            <IconLabel iconId={'share-bluesky'} className={classes['share-list__item']} />
          </BlueskyShareButton>
        )}
      </div>
    );
  }
);
